import "./css.d.ts";
import { cls } from "./utils/cls";
import styles from "./IconWrapper.module.css";
import { forwardRef, type HTMLAttributes } from "react";

export const IconWrapper = forwardRef<
  HTMLSpanElement,
  HTMLAttributes<HTMLSpanElement>
>(function IconWrapper(props, ref) {
  const { className, ...otherProps } = props;
  return (
    <span ref={ref} className={cls(className, styles.root)} {...otherProps} />
  );
});
